export const getStyles = () => ({
    styles: {
      container: {
        display: "flex",
        alignItems: "center", 
        justifyContent: 'space-between',
      },
      message : {
        fontSize: 10, 
        lineHeight: '16px', 
        color:'#138267',
      },
    },
  });